import {
  Modal,
  ModalActionButton,
  ModalActions,
  ModalCloseIconButton,
  ModalContent,
  ModalTitle,
  Typography,
} from '@ace-clublabs/shared-component-library';
import { useLayoutEffect, useState } from 'react';
import { useGlobalState } from '../../state/state';
import { UtagHelper, UtagType } from '../../utils/UtagHelper';

export interface IPITWarningModalProps {
  onClose: () => void;
  visible: boolean;
}

export const PITWarningModal = ({ onClose, visible }: IPITWarningModalProps) => {
  const [tags] = useGlobalState('tags');
  const [isTagging, setTagging] = useState(true);

  useLayoutEffect(() => {
    if (visible) {
      UtagHelper.sendTag(UtagType.view, tags, 'pit block');
      setTagging(false);
    }
  }, [visible]);

  if (isTagging) {
    return <></>;
  }

  return (
    <Modal id="pit-warning-modal" open={visible} size="small" onClose={onClose}>
      <ModalTitle id="pit-warning-title">
        Unable to make membership changes
        <ModalCloseIconButton
          aria-label="Close"
          id="modalCloseButton"
          onClick={() => {
            onClose();
          }}
        />
      </ModalTitle>
      <ModalContent id="pit-warning-content">
        <Typography variant="b1Regular" sx={{ marginBottom: '1rem' }}>
          You currently cannot make changes to your membership because you have a payment or membership update in
          progress. Please try again later or call us for assistance.
        </Typography>
      </ModalContent>
      <ModalActions
        actionLayout={{
          xs: 'fullWidth',
          sm: 'fullWidth',
          md: 'fullWidth',
          lg: 'fullWidth',
          xl: 'fullWidth',
        }}
      >
        <ModalActionButton
          id="pit-warning-call-button"
          label={'Call 1-844-786-1615'}
          onClick={() => {
            window.open('tel:18447861615');
          }}
          variant="outlined"
          fullWidth
          sx={{
            color: '#FFFFFF;',
            backgroundColor: '#0C72DF',
            borderRadius: '6px',
            padding: '9px !important',
          }}
        />
      </ModalActions>
    </Modal>
  );
};
